import { host } from '@/utilities/apiEndPoints'
import { endpointsApi } from '@/reducers/endpoints/endpointsSlice'

export const useSiteCountry = () => {
  const { country } = endpointsApi.endpoints.getSiteConfig.useQueryState(host, {
    selectFromResult: ({ data }) => ({ country: data?.country }),
  })
  return country
}
